import { createStore, applyMiddleware, compose, combineReducers } from 'redux'
import thunkMiddleware from 'redux-thunk'
import { browserHistory } from 'react-router'
import { syncHistory } from 'react-router-redux'
import rootReducer from 'services/rootReducer'
import promiseMiddleware from 'application/middleware/promiseMiddleware'
import localCacheMiddleware from 'application/middleware/localCacheMiddleware'
import devToolsMiddleware, { listenForReplays } from 'application/middleware/devToolsExtension'
import { notificationMiddleware } from 'application/middleware/notificationMiddleware'
import unauthorizedMiddleware from 'application/middleware/unauthorizedMiddleware'
import actionListenerStoreEnhancer from './actionListenerStoreEnhancer'

const reduxRouterMiddleware = syncHistory(browserHistory) // sync dispatched route actions to the history

export default function configureStore (initialState, apis = {}) {
  const middleware = [
    reduxRouterMiddleware,
    thunkMiddleware.withExtraArgument(apis),
    localCacheMiddleware(initialState.bootup.localCacheNonce),
    promiseMiddleware,
    unauthorizedMiddleware,
    notificationMiddleware,
  ]
  const store = createStore(
    combineReducers(rootReducer),
    initialState,
    compose(
      applyMiddleware(...middleware),
      actionListenerStoreEnhancer,
      devToolsMiddleware()
    ),
  )

  listenForReplays(reduxRouterMiddleware, store) // required for replaying actions from devtools to work

  return store
}



// WEBPACK FOOTER //
// ./src/application/store/configureStore.prod.js